import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=17aa6a6f&scoped=true&"
import script from "./canvas.vue?vue&type=script&lang=js&"
export * from "./canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa6a6f",
  null
  
)

export default component.exports